export const DISPUTE_CATEGORY_PAYMENT = 'payment';
export const DISPUTE_CATEGORY_JOB = 'task';

export const isJobDispute = (row) =>
    String(row?.type || '').toLowerCase() === DISPUTE_CATEGORY_JOB;

export const formatDisputeCategoryLabel = (dispute) =>
    isJobDispute(dispute) ? 'Job / escrow dispute' : 'Payment dispute';

/** Red accent for job / escrow disputes (category cards, badges, links). */
export const JOB_DISPUTE_ACCENT = {
    activeCard:
        'border-red-400 bg-red-50 shadow-sm ring-1 ring-red-200 dark:border-red-700 dark:bg-red-950/40 dark:ring-red-900/50',
    icon: 'text-red-600 dark:text-red-400',
    countPill:
        'bg-red-600/10 text-red-800 dark:text-red-300',
    categoryBadge:
        'border-red-300 bg-red-50 text-red-900 dark:border-red-700 dark:bg-red-950/50 dark:text-red-200',
    linkButton:
        'border-red-300 bg-red-50 text-red-900 hover:bg-red-100 dark:border-red-700 dark:bg-red-950/50 dark:text-red-200 dark:hover:bg-red-950/70',
    monoText: 'text-red-800 dark:text-red-300',
    statCard:
        'border-red-200/80 bg-red-50/90 dark:border-red-900/50 dark:bg-red-950/35',
    statLabel: 'text-red-800 dark:text-red-300/90',
};
